module.exports = __webpack_public_path__ + "static/media/5.d1c37e9d.jpg";